import { animate, state, style, transition, trigger } from '@angular/animations';
import { DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, effect, EventEmitter, Input, Output, Renderer2, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { ContactSalesComponent } from 'src/app/common/components/contact-sales/contact-sales.component';
import { actionIdConstants, tableTitle } from 'src/app/common/constants/common.contants';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { layerConstant } from 'src/app/common/constants/layer-constant';
import { activityPayload } from 'src/app/common/models/userActivity.model';
import { SharedService } from 'src/app/common/services/shared.service';
import { UserService } from 'src/app/common/services/user.service';
import { ReportTableDropdown, tableDropdown } from 'src/app/reports/components/reports-lists/models/reports.model';
import { ReportsViewEnum } from 'src/app/reports/models/enums/reports.enum';
import { ReportMapService } from 'src/app/reports/services/report-map.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-warehouse-inventory-property-transaction',
  templateUrl: './warehouse-inventory-property-transaction.component.html',
  styleUrls: ['./warehouse-inventory-property-transaction.component.scss'],
   animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class WarehouseInventoryPropertyTransactionComponent {

  @Input() tableColumns: any = [];
      @Input() tableData: any = [];
      @Input() showLoader: boolean = true;
      @Input() dataLength: number = 0;
      @Input() downloadLoading: any;
      @Input() resetPaginator: any;
      @Output() pageEvent: EventEmitter<PageEvent> = new EventEmitter();
      @Output() sort: EventEmitter<Sort> = new EventEmitter();
      @Output() excelDownload: EventEmitter<boolean> = new EventEmitter();
      @ViewChild(MatPaginator) matPaginator: MatPaginator | any;
      @ViewChild(MatSort) matSort!: MatSort;
      @Input() dropDownOption: ReportTableDropdown | null = null;
      @Output() dropDownValue: EventEmitter<boolean> = new EventEmitter();

      startIndex: number = 1;
      // @Output() lastClickedTable: EventEmitter<any> = new EventEmitter();
      expandedElement: any = [];
      current_lang: any = 'en';
      CurrencyCode: string = '';
      languageSub$: Subscription = new Subscription();
      selectedIndex: string | null = null;
      colType: string = '';
      tenantLoading: boolean = false;
      expandbgColor = '';
      LockReport: boolean = true;
      totalPages: number | any;
      maxIndexValue: number = 20;
      endIndex: number = 20;
      goToPageNumber: number = 1;
      previousPageNbr: number = 1;
      allowDownload: boolean = false;
      currentReportData: any = null;
    
      BHRCHECK = environment.BHRCHECK;
      placeCode:any;
      reportId!: number;

      selectedOptions:any = [];
    
      constructor(
        private sharedService: SharedService,
        private translate: TranslateService,
        private mapService: ReportMapService,
        private reportService: ReportService,
        private alertService: AlertService,
        private _decimalPipe: DecimalPipe,
        private cdr: ChangeDetectorRef,
        private elementRef: ViewContainerRef,
        private ren: Renderer2,
        private matdailog: MatDialog,
        private userService: UserService,
        private route: ActivatedRoute
      ) {
        effect(() => this.selectedIndex = this.mapService.selectedIndex())
        this.languageSub$ = this.sharedService.language$.subscribe((lang) => {
          setTimeout(() => this.current_lang = lang)
          this.CurrencyCode = this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode));
           this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
        });
        /**
         * year dropdown click trigger subscribe
         */
        this.sharedService.yearTrigger.subscribe((res: any) => {
          if (res) {
            this.startIndex = 1;
            this.endIndex = (this.maxIndexValue && this.dataLength) ? Math.min(this.maxIndexValue, this.dataLength) : 20;
          }
        })
      }
      ngOnInit(): void {
          this.currentReportData = this.reportService.getCurrentReport();
          this.setDownloadAccess();
          this.CurrencyCode = this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode));
          this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
          this.dropDownOption?.data.forEach((data: tableDropdown) => {
              this.selectedOptions.push(data.id)
            })
            
          this.reportId = this.route.snapshot.queryParams['rid'];
        }
      ngOnChanges(changes: SimpleChanges): void {
        this.LockReport = this.reportService.getLockReport();
        this.setTableDataSource(this.tableData);
        if ((changes['tableData']?.previousValue?.length <= 0 || !changes['tableData']?.previousValue) && !changes['showLoader']?.previousValue) {
          this.endIndex = (this.maxIndexValue && this.dataLength) ? Math.min(this.maxIndexValue, this.dataLength): 20;
        }
        if (changes['dataLength'] && changes['dataLength']?.currentValue) {
          this.goToPageNumber = 1;
          this.startIndex = 1;
          this.endIndex = this.maxIndexValue && changes['dataLength']?.currentValue ?  Math.min(this.maxIndexValue, changes['dataLength']?.currentValue) :20;
        }
      }
      ngAfterViewInit(): void {
        if(this.matSort) this.matSort.disableClear = true;
        // this.tableDataSource.paginator = this.matPaginator;
        // this.tableDataSource.sort = this.matSort;
    
      }
      isChildOpen(ele: any, pIndex: number) {
        const currentExpand = ele.expand;
        for (let j = 0; j < this.tableData.length; j++) {
          if (this.tableData[j].isParent) {
            this.tableData[j].expand = false; // Collapse all children
          }
        }
        ele.expand = !currentExpand;
        //Click to update element collapse
        this.onParentClick(pIndex)
        // Trigger change detection to update the UI
        this.tableData = [...this.tableData];
      }
      onParentClick(parentIndex: number): void {
        if (this.tableData[parentIndex].isParent) {
          // Toggle the expand state of the clicked parent
          const isCurrentlyOpen = this.tableData[parentIndex].expand;
          // Iterate through the data and collapse all children first
          for (let j = 0; j < this.tableData.length; j++) {
            if (!this.tableData[j].isParent) {
              this.tableData[j].isOpen = 1; // Collapse all children
            }
          }
          // Expand or collapse the children of the clicked parent
          let i = parentIndex + 1;
          while (i < this.tableData.length && !this.tableData[i].isParent) {
            this.tableData[i].isOpen = isCurrentlyOpen ? 2 : 1;
            i++;
          }
        }
      }
      async panToMap(value: any, columnName: any, index?: any, type: string = '', isPropertyName: boolean = false, isFloorLayout: boolean = false, unit_layout: boolean = false) {
        this.colType = type;
        // this.lastClickedTable?.emit();
        if (type) this.selectedIndex = this.goToPageNumber.toString() + index.toString();
        this.reportService.reportView$.next(ReportsViewEnum.mapGridView);
        //   if (JSON.stringify(value) === JSON.stringify(this.lastParams)) {
        //     return;
        // }
        // this.lastParams = value;
        let layer_data = this.reportService.getCurrentReport();
     const activity:activityPayload = {
          userdata: { ...value, report_section:tableTitle.propertyTransactions, },
          actionId: actionIdConstants.show_on_map,
          entity: 'report',
          entityId: this.reportId,
        };
        this.userService.logUserActivity(activity);
        if (value?.lat && type != 'layout') {
          if (!value.project_name && (value.neigh_name || value.neighbourhood || value.neighborhood) && columnName !== 'transaction_date' && columnName !== 'property_name') {
            let layerdat = layer_data?.map_layer?.filter((r: any) => r.layer_name == "neighbourhoods")[0];
            let zoom = 13
            if (layerdat) {
              layerdat.display = true;
              zoom = (Math.ceil((layerdat.maxZoom - layerdat.minZoom) / 2) + layerdat.minZoom);
            }
            this.mapService.overlay_mapLayer_selected.next([layerdat]);
    
            this.mapService.mapCoordinates.next({ coordinates: [value.lat, value.lon], zoom: zoom, uid: value?.property_uid, layer_name: 'neighbourhood' });
          }
          if (value.project_name && columnName !== 'transaction_date' && columnName !== 'property_name') {
            // let layerdat = layer_data?.map_layer?.filter((r: any) => r.layer_name == "project_layer")[0];
            let layerdat = layer_data?.map_layer?.find((r: any) => r.layer_name == layerConstant.miprojects);
            let zoom = 16;
            if (layerdat) {
              layerdat.display = true;
              zoom = (Math.ceil((layerdat.maxZoom - layerdat.minZoom) / 2) + layerdat.minZoom);
              layer_data?.map_layer?.map((r: any) => r.layer_name == layerConstant.miprojects)
            }
    
            this.mapService.overlay_mapLayer_selected.next([layerdat]);
            value['proj_name'] = value?.project_label;
            this.mapService.mapCoordinates.next({ coordinates: [value.lat, value.lon], zoom: zoom, uid: value?.property_uid, layer_name: 'project', data: value, isNameClicked: isPropertyName, isFloorLayout, columnName: columnName });
          }
          //On clicking the transaction_date column, only the map will pan.
          if (columnName === 'transaction_date' || columnName === 'p_property_name' || columnName === 'property_project_name' || columnName === 'property_name'
            || columnName == 'tenant_name' || columnName == 'unit_number' || columnName == 'type'
          ) {
            let uid = value?.property_uid || value?.p_property_uid;
            this.tenantLoading = true;
            try {
              const propertyData: any = await this.mapService.getParcelInfo(uid);
              this.tenantLoading = false;
              if (propertyData.status == 200 && propertyData?.data?.length) {
                let properties = { ...propertyData.data[0], is_layout: value?.is_layout };
                // properties['proj_name'] = properties?.project_name;
                if(properties?.project_name) properties['proj_name'] ={1: properties?.project_name, 2:''};
                this.mapService.mapCoordinates.next({ coordinates: [value.lat, value.lon], zoom: 18, uid: uid, layer_name: 'property', data: properties, isNameClicked: isPropertyName, isFloorLayout, columnName: columnName });
                if (isFloorLayout) {
                  this.showLayout(properties);
                }
              } else {
                this.alertService.warn(this.translate.instant("reports.no_record_found"));
              }
            } catch (error) {
              this.tenantLoading = false;
              this.alertService.warn("Something went Wrong!, Try Again");
            }
          }
        }
        if (type == 'showOnMap' && value?.tenants_lat_lon) {
          if (value?.shop_name) {
            this.tenantLoading = true;
            this.reportService.retailInventoryTenantDetails(value.shop_name).subscribe((item: any) => {
              if (item.status == 200) {
                this.tenantLoading = false;
                this.mapService.mapCoordinates.next({ data: item.data, multiLatLon: true, tenant_name: value?.tenant_name, zoom: 18 });
              } else { this.alertService.warn(this.translate.instant("reports.no_record_found")); this.tenantLoading = false };
            })
          } else {
            this.alertService.warn(this.translate.instant("reports.no_record_found"));
          }
          // this.mapService.mapCoordinates.next({coordinates:value?.tenants_lat_lon, multiLatLon: true, tenant_name: value?.tenant_name});
        }
        if (type == 'layout' && !unit_layout) {
          this.reportService.reportView$.next(ReportsViewEnum.mapGridView);
          this.showLayout(value, true)
        }
        if (type == 'layout' && unit_layout) {
          this.showTenant(value);
        }
      }
      showLayout(value: any, is_unit_layout?: boolean) {
        if (is_unit_layout) value['is_unit_layout'] = true;
        this.mapService.propertyinfotoggle.next(true);
        this.mapService.selected_propertydetails.next(value);
        this.reportService.showTenantMap$.next(value);
      }
      showTenant(value: any) {
        this.reportService.showUnitTenantMap$.next(value);
      }
      isCharNumber(value: any) {
        const toolTipValue = typeof value === 'string' ? value : this._decimalPipe.transform(value, '1.0-1');
        return `${toolTipValue} ${this.translate.instant(this.CurrencyCode)}/${this.translate.instant(GlobalContants.keySymbolContants.squareMeterUnit)}`;
      }
      setExpadndColor(index: number) {
        //  this.expandbgColor = index % 2 === 0 ? '#F5F5F5' : '#FFFFFF';
        this.expandbgColor = '#EBF1FF';
      }
      setTableDataSource(data: any): void {
        // lock table rows
        this.LockReport = this.reportService.getLockReport();
        if (this.LockReport) {
          data = data.slice(0, 3);
    
          for (let i = 0; i < 3; i++) {
            let temp: any = {};
            this.tableColumns.map((e: any) => {
              temp[e.field] = e.convertNumber ? 1111111 : 'No data'
              temp['NODATA'] = true;
            })
            data.push(temp);
          }
          this.tableData = data;
        } else {
          this.tableData = data;
        }
        // lock table rows
        //Add Element between arrows
        this.cdr.detectChanges();
        if (this.matPaginator) {
          this.totalPages = this.matPaginator.getNumberOfPages();
          this.addGoToPageInput();
        }
      }
      addGoToPageInput() {
        const actionContainer = this.elementRef.element.nativeElement.querySelector('div.mat-mdc-paginator-range-actions');
        const nextButtonDefault = this.elementRef.element.nativeElement.querySelector('button.mat-mdc-paginator-navigation-next');
        let bubbleContainerRef: any = this.ren.createElement('div') as HTMLElement;
        this.ren.addClass(bubbleContainerRef, 'g-bubble-container');
        this.ren.insertBefore(actionContainer, bubbleContainerRef, nextButtonDefault);
        bubbleContainerRef.appendChild(this.elementRef.element.nativeElement.querySelector('.go-to-page'));
      }
      openContactSales() {
        this.matdailog.open(ContactSalesComponent, {
          width: '600px',
          maxHeight: '95vh',
          panelClass: 'contact-form',
          data: { Type: 'contact_us' }
        })
      }
      onPageChange(event: any) {
        this.pageEvent.emit(event)
        this.startIndex = event.pageIndex * event.pageSize + 1;
        this.endIndex = Math.min((event.pageIndex + 1) * event.pageSize, event.length);
        this.goToPageNumber = (event.pageIndex || 0) + 1;
      }
      onGoToPage() {
        if (this.goToPageNumber > this.totalPages || this.goToPageNumber <= 0) {
          this.goToPageNumber = this.previousPageNbr;
          return;
        }
        this.previousPageNbr = this.goToPageNumber;
        this.matPaginator.pageIndex = this.goToPageNumber - 1;
        const event: PageEvent = {
          length: this.matPaginator.length,
          pageIndex: this.matPaginator.pageIndex,
          pageSize: this.matPaginator.pageSize
        };
        this.goToPageNumber = (event.pageIndex || 0) + 1;
        this.onPageChange(event);
      }
      onSortTable(event: any) {
        if (this.tableData?.length === 0 || !this.tableData) return;
        if(this.selectedOptions) {
          event = {...event}
          event['selectedOptions'] = this.selectedOptions
          this.sort.emit(event)
        }else {
          this.sort.emit(event)
        }
        //click to sorting reset pagenumber & index
        this.goToPageNumber = 1;
        this.startIndex = 1;
        this.endIndex = Math.min(this.maxIndexValue, this.dataLength);
        this.resetPageIndex();
        this.mapService.resetMarker.next(true);
      }
      resetPageIndex() {
        if (this.matPaginator) {
          this.matPaginator.pageIndex = 0;
        }
      }
      downloadExcel() {
        let subscription = this.reportService.userSubscription.find((sub: any) => sub.report_id === this.currentReportData?.id);
        if (subscription) {
          this.allowDownload = subscription.allow_download && this.currentReportData?.is_download;
        }
        if (!this.allowDownload) {
          this.alertService.warn(this.translate.instant("reports.disableDownloadAccessMsg"));
          return;
        }
          const activity:activityPayload = {
          userdata: { report_section: tableTitle.propertyTransactions },
          actionId:actionIdConstants.download_data,
          entity: 'report',
          entityId: this.reportId,
           };
          this.userService.logUserActivity(activity);
        this.excelDownload.emit(true);
      }
      setDownloadAccess() {
        let subscription = this.reportService.userSubscription.find((sub: any) => sub.report_id === this.currentReportData?.id);
        if (subscription) {
          this.allowDownload = subscription.allow_download && this.currentReportData?.is_download;
        }
      }

      selectCheckboxValue(event: any, id: string, value: string) {
        if (event.checked) {
          this.selectedOptions.push(id);
        } else {
          this.selectedOptions = this.selectedOptions.filter((optionId:any) => optionId !== id);
        }
        this.dropDownValue.emit(this.selectedOptions);
        this.mapService.resetMarker.next(true);
      }
}
